import styled from "styled-components"
import { useEffect } from "react"
import { useSelector } from "react-redux"
import ResultsCard from "./components/ResultsCard"
import { COLORS } from "../../constants"
import { Link } from "react-router-dom"
import { useState } from "react";
import axios from "axios"
import ReactLoading from "react-loading"

const StyledCardContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-left: -5px;
    margin-right: -5px;
    margin-top: 10px;
`;
const colors = [
    {
        bgColor: COLORS.level_one,
        color: COLORS.level_one_text
    },
    {
        bgColor: COLORS.level_two,
        color: COLORS.level_two_text
    },
    {
        bgColor: COLORS.level_three,
        color: COLORS.level_three_text
    },
    {
        bgColor: COLORS.level_four,
        color: COLORS.level_four_text
    },
    {
        bgColor: COLORS.level_five,
        color: COLORS.level_five_text
    },
    {
        bgColor: COLORS.level_six,
        color: COLORS.level_six_text
    }
]
export default function MyResults() {
    const api = process.env.REACT_APP_API_URL;
    const user = useSelector(state => state.auth.user.user);
    const [levelResults, setLevelResults] = useState([]);
    const [loading, setLoading] = useState(true);


    useEffect(async () => {
        const response = await axios.get(`${api}/cp/pupil_levels_set/${user.pupil_id}`);
        const data = response.data;
        if (data) {
            setLoading(false)
            setLevelResults(data.levels)
            // console.log(data)
        }
    }, [])
    return (
        <StyledCardContainer>
            {loading ?
                <div className="w-100 d-flex justify-content-center">
                    <ReactLoading type="bubbles" color={COLORS.green} height={130} width={200} />
                </div>
                :
                <>
                    {levelResults.map((level, i) => {
                        if (level.questions_answered == 0) {
                            return <div className="grid-card" key={i}>
                                <ResultsCard bgcolor={colors[i].bgColor} textcolor={colors[i].color} content={i + 1}>

                                    <h5 className="mt-2 mb-2">Level {i + 1}</h5>

                                    <span style={{ color: colors[i].bgColor }}>No Results Yet</span>
                                </ResultsCard>
                            </div>
                        } else {
                            return <Link to={`/dashboard/results/${i + 1}`} className="grid-card" key={i}>
                                <ResultsCard bgcolor={colors[i].bgColor} textcolor={colors[i].color} content={level.level_no}>
                                    <h5 className="mt-2 mb-2">Level {level.level_no}</h5>
                                    <div className="color-text-grey">Words Learned</div>
                                    <span style={{ fontSize: 23, color: colors[i].bgColor }} className="mb-3" >{level.words_learned}<span style={{ color: "black" }}>/300</span></span>
                                    {/* <span style={{ fontSize: 19 }} className="color-text-grey mb-3">{Math.round(level.average_score * 100) / 100}<span style={{ color: "black" }}>/10</span></span> */}

                                </ResultsCard>
                            </Link>
                        }
                    })}
                </>}
        </StyledCardContainer >
    )
}
